import AllCategories from './AllCategories';

export default AllCategories;
